import {
  faClipboard,
  faClipboardCheck,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { round } from 'mathjs';
import React, { useState, useContext, useEffect } from 'react';
import { AllInputDataContext, SliderValuesContext } from '../../../../config';
import styles from './SocialPopUp.module.css';
import { Button, Typography, message } from 'antd';
import { logEvent } from 'firebase/analytics';
import { valueToSize } from '../../../controls/MEControls';
import { analytics } from '../../../../index';
import { groupBy } from 'underscore';
import { faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
const { Text, Title } = Typography;

const SocialPopUp = ({
  userScore,
  optionsData,
  setUserScorePopup,
}: {
  userScore: number;
  optionsData: any;
  setUserScorePopup: any;
}) => {
  const { technologyData } = useContext(AllInputDataContext);
  const sliderValues = useContext(SliderValuesContext);
  const [isCopied, setIsCopied] = useState(false);
  const alertLevel = 'alertLevel' + round(((100 - userScore) * 4.9999) / 100);

  const plants = technologyData
    .filter((tech) => tech.name !== 'Blackout')
    .map((data) => ({
      name: data.name,
      value: valueToSize(sliderValues[data.id - 1], data.capMax),
    }));

  useEffect(() => {
    logEvent(analytics, 'score_pop_up', {
      items: JSON.stringify({ score: userScore, plants }),
    });
  }, []);

  const facebook = () => {
    logEvent(analytics, 'facebook_share', {
      items: JSON.stringify({ score: userScore, plants }),
    });

    window.open(
      `https://www.facebook.com/sharer.php?u=https%3A%2F%2F${window.location.host}`,
      '_blank'
    );
  };

  const linkedIn = () => {
    logEvent(analytics, 'linkedIn_share', {
      items: JSON.stringify({ score: userScore, plants }),
    });

    window.open(
      `https://www.linkedin.com/shareArticle?url=https%3A%2F%2F${window.location.host}`,
      '_blank'
    );
  };

  const groupedPlants = groupBy(plants, (plant) => plant.value);
  const plantSizes = [
    // { value: 'off', label: 'X' },
    { value: 'small', label: 'S' },
    { value: 'medium', label: 'M' },
    { value: 'large', label: 'L' },
  ];

  const copy =
    `I scored ${userScore}% with my Australian energy grid...\n\n` +
    plantSizes
      .map((size) =>
        groupedPlants?.[size.value]?.length
          ? size.label +
            ':' +
            groupedPlants?.[size.value].map((plant) => plant.name).join(', ') +
            '\n'
          : ''
      )
      .join('') +
    `\nGive it a go on\nhttps://modelling.energy #Ibalancedthegrid`;

  const copyScore = () => {
    navigator.clipboard
      .writeText(copy)
      .then(() => {
        setIsCopied(true);
        message.success('Copied, select a social platform below', 10);
      })
      .catch(() => {
        message.error(
          'Copying was blocked by your browser, select the text and copy manually',
          10
        );
      });
  };

  return (
    <>
      <div className={styles.container}>
        <div
          className={styles.outerFrame}
          onClick={() => setUserScorePopup(false)}
        ></div>
        <div className={styles.popupContainer}>
          <div
            className={styles.popupContentContainer}
            style={{
              backgroundColor: optionsData[alertLevel],
              display: 'flex',
              flexDirection: 'column',
              gap: 5,
            }}
          >
            <FontAwesomeIcon
              className={styles.close}
              icon={faTimes}
              onClick={() => setUserScorePopup(false)}
            />
            <Title level={2} style={{ margin: 0 }}>
              Great job! You’ve balanced the energy grid.
            </Title>
            <Title level={4} style={{ margin: 5 }}>
              Your score is
            </Title>
            <Title className={styles.score}>{userScore}%</Title>

            <Text style={{ textAlign: 'center' }}>
              <strong>
                You balanced energy Cost, Emissions and Security by using:
              </strong>
            </Text>
            <table className={styles.plantSizeSummary}>
              {plantSizes.map((size) =>
                groupedPlants?.[size.value]?.length ? (
                  <tr key={size.label}>
                    <td>
                      <b>{size.label}</b>
                    </td>
                    <td>
                      {groupedPlants?.[size.value]
                        .map((plant) => plant.name)
                        .join(', ')}
                    </td>
                  </tr>
                ) : null
              )}
            </table>
            <Text style={{ textAlign: 'center' }}>
              Share your results and compare with others.
            </Text>
            <Button
              icon={
                <FontAwesomeIcon
                  icon={isCopied ? faClipboardCheck : faClipboard}
                />
              }
              type="primary"
              onClick={copyScore}
            >
              {isCopied ? 'Copied!' : 'Click to copy score'}
            </Button>
            <div className={styles.leaderBoardLink}>
              <Button
                icon={<FontAwesomeIcon icon={faFacebookF} />}
                type="primary"
                onClick={facebook}
                style={{ backgroundColor: '#1877F2' }}
              >
                Share on Facebook
              </Button>

              <Button
                icon={<FontAwesomeIcon icon={faLinkedinIn} />}
                type="primary"
                onClick={linkedIn}
                style={{ backgroundColor: '#0077B5' }}
              >
                Share on LinkedIn
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SocialPopUp;
